module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-2.3697ba93.JPG";